// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { IBlogModel } from "@vanmeter/XDL/types";
import { Draft } from "immer";

export type BlogDetailsPageState = Readonly<{
    [key: string]: IBlogModel;
}>;

const initialState: BlogDetailsPageState = {};

const reducer = {
    "xBlogDetailsPage/SetBlog": (draft: Draft<BlogDetailsPageState>, action: { blogId: string; blog: IBlogModel }) => {
        draft[action.blogId] = action.blog;
    },
};

const xBlogDetailsPage = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xBlogDetailsPage = xBlogDetailsPage;

export type xBlogDetailsPageState = {
    xBlogDetailsPage: BlogDetailsPageState;
} & ApplicationState;

type BlogDetailsPageReducers = {
    query: typeof xBlogDetailsPage;
};

export type xBlogDetailsPage = Parameters<BlogDetailsPageReducers[keyof BlogDetailsPageReducers]>[1] | AnyAction;
